/**
 * Alert Component
 */

import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityComponent } from 'velocity-react';

import { Span } from '../../../atoms/text/Label';

interface IOwnProps {
  className?: string;
  message: string;
  visible: boolean;
}

const classes = new BEM('alert');

export default class Alert extends React.Component<IOwnProps, {}> {

  render() {
    const {
      className,
      message,
      visible,
    } = this.props;

    const extraClasses = classNames(className);

    return (
      <VelocityComponent animation={{ translateY: visible ? 0 : '-100%' }}>
        <div {...classes('', '', extraClasses) }>
          <Span variant="description">{message}</Span>
        </div>
      </VelocityComponent>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/messaging/Alert/index.tsx